const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/registerstudentpay/homepage'], resolve)
}

export default homepage
